// loading view
// nonowner view
// owner view
<template>
  <div>
    <b-jumbotron
      :header="data['name']"
      :lead="data['balance']"
    >
      <div class="w-100 text-right">
        <b-avatar button icon="arrow-right" disabled></b-avatar>
      </div>
    </b-jumbotron>
  </div>
</template>
<script>
export default {
    props: ['tokenId'],
    data(){
        return {
            loading: true, 
            data: null,
        }
    },
    methods: {
        getData() {
            this.loading = true;
            this.$store
            .dispatch("ethereum/getTokenData", this.tokenId)
            .then((ipfs) => {
                if (!ipfs) {
                    throw new Error("No metadata");
                }
                let link = ipfs.indexOf("https://") > -1 ? ipfs : "https://" + ipfs + ".ipfs.dweb.link";
                fetch(link)
                .then((response) => response.json())
                .then((json) => {
                    this.data = json;
                    this.removeIssue("metadata");
                });
            })
            .catch((err) => {
                this.$bvToast.toast(err["message"] || err, {
                    title: "Error",
                    variant: "danger",
                });
            })
            .finally(() => {
                this.loading = false;
            });
        },
    }
};
</script>